<template>
	<div>
		<div class="input-container">
			<div class="input-title">Field Name</div>
			<div class="input-box"><input v-model="value.name" type="text"></div>
		</div>
		<div class="input-container">
			<div class="input-title add-border-bottom">Field Slug</div>
			<div class="input-box"><slug-field v-model="value.slug" :base-field="value.name" separator="_"></slug-field></div>
		</div>
	</div>
</template>

<script>

export default {

	props: ['value'],

};

</script>
